<div [ngClass]="customClass">
  <ng-container *ngIf="data || data < 0 || data === 0; else emptyTmpl">
    {{ data }}
  </ng-container>
</div>
<ng-template #emptyTmpl>
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</ng-template>
